import "./Signup_brand.css";
import "../components/fonts.css";
import logo from "../assets/logo.png";
import Submit_button from "../components/submit_button.js";
import Header from "../components/header.js";
import { useState } from "react";
import { toast, Toast, Toaster } from "react-hot-toast";

function Signup_brand() {
  const [email, SetEmail] = useState("");

  const handleEmailInputChange = (event) => {
    SetEmail(event.target.value);
  };

  const handleSubmit = () => {
    if (email.length === 0) {
      toast.error("Please enter your email!");
    } else {
      toast.success("email sent successfully!");
      //send email to contact@happer.fr
    }
  };

  return (
    <>
      <Header user="brand" title="Connexion" />
      <div className="Signup_brand">
        <Toaster toastOptions={{ duration: 2000 }} />
        <img className="Happer_image" src={logo} alt="Happer LOGO" />
        <p className="Happer_text">
          Développez votre marque sur de nouveaux marchés
        </p>
        <p className="hint">
          Des contenus de haute qualité sont diffusés quotidiennement par nos
          <br />
          influenceurs auprès de larges audiences prêtes à acheter
        </p>
        <p className="hint">
          Evoluer vos projets de marketing d'influence avec Happer et maximisez
          <br />
          le routeur sur investissement de votre marketing d'influence
        </p>
        <input
          type="tel"
          name="phone-number"
          value={email}
          onChange={handleEmailInputChange}
          placeholder="Votre email"
          required
        />
        <Submit_button title="Démarrer avec Happer" onClick={handleSubmit} />
        <div style={{ marginBottom: "200px" }}></div>
      </div>
    </>
  );
}

export default Signup_brand;
